// Thin wrapper around window.fbq (Meta Pixel base snippet lives in index.html).
// Guards every call so pages/tests without the pixel script loaded don't throw.

export function trackPageView() {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", "PageView");
  }
}

export function trackEvent(eventName, params) {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", eventName, params || {});
  }
}
